<template>
  <div class="row">
      <div class="col-3">
        <div class="row mb-2" style="background-color: #ccc;padding: 5px; border-right: solid 1px #efefef;">
          <div class="col-12 text-center">
            <strong>SEMANA 1</strong>
          </div>
        </div>
        <Week v-for="i in repeat" :key="i" :value="i"/>
      </div>
      <div class="col-3">
        <div class="row mb-2" style="background-color: #ccc;padding: 5px;border-right: solid 1px #efefef;">
          <div class="col-12 text-center bg-gray">
            <strong>SEMANA 2</strong>
          </div>
        </div>
        <Week v-for="i in repeat" :key="i" :value="i"/>
      </div>
      <div class="col-3">
        <div class="row mb-2" style="background-color: #ccc;padding: 5px;border-right: solid 1px #efefef;">
          <div class="col-12 text-center bg-gray">
            <strong>SEMANA 3</strong>
          </div>
        </div>
        <Week v-for="i in repeat" :key="i" :value="i"/>
      </div>
      <div class="col-3">
        <div class="row mb-2" style="background-color: #ccc;padding: 5px;border-right: solid 1px #efefef;">
          <div class="col-12 text-center bg-gray">
            <strong>SEMANA 4</strong>
          </div>
        </div>
        <Week />
      </div>
  </div>
</template>
<script>
import Week from './week'
export default {
  name: 'agenda',
  data () {
    return {
      repeat: 2
    }
  },
  components: {
    Week
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/sg/agenda/agenda.vue